import BaseStyle from './basler-components.es684.js';

var inlineStyles = {
  root: {
    position: 'relative'
  }
};
var classes = {
  root: 'p-chart'
};
var ChartStyle = BaseStyle.extend({
  name: 'chart',
  classes: classes,
  inlineStyles: inlineStyles
});

export { ChartStyle as default };
